import { createSelector } from "reselect";

export const branchesSelector = createSelector(
    state => state.services.branch,
    state => state
);